import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AutenticationService from '../services/Authentication.service';
import { menu1 } from '../constants/Constants';

const FloatingButton = ({ 
  containerClass, 
  buttonClass, 
  menuClass, 
  textClass, 
  showUserTextsInMenu 
}) => {
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuVisible(prevState => !prevState);
  };

  const handleClickOutside = (e) => {
    if (
      e.target.closest(`.${containerClass}`) ||
      e.target.closest(`.${menuClass}`)
    ) {
      return;
    }
    setIsMenuVisible(false);
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const userName = AutenticationService.getUserNameComplete();
  const userEmail = AutenticationService.getEmail();
  const isLogger = AutenticationService.getIsLogged();

  return (
    isLogger&&
    <div className={containerClass} onClick={toggleMenu}>
      <button className={buttonClass}>
        {userName[0].toUpperCase()}
      </button>

      {isMenuVisible && (
        <ul className={menuClass}>
          {showUserTextsInMenu && (
            <li>
              <div className={textClass}>
                <p
                  className="user-name"
                  title={userName}
                >
                  {userName}
                </p>
                <p className="user-email" title={userEmail}>
                  {userEmail}
                </p>
              </div>
            </li>
          )}

          {menu1.map((item) => (
            <li key={item.id} className="menu-item" onClick={()=>{ window.open(item.url, '_blank')}} >
              <a href={item.url} target='_blank'></a>
              {item.text}
            </li>
          ))}

          <li>
            <Button
              className="w-100 btn-rounded1"
              onClick={() => {
                navigate('/login');
              }}
            >
              Cerrar sesión
            </Button>
          </li>
        </ul>
      )}

      {!showUserTextsInMenu && (
        <div className={textClass}>
          <p
            className="user-name"
            title={userName}
          >
            {userName}
          </p>
          <p className="user-email" title={userEmail}>
            {userEmail}
          </p>
        </div>
      )}
    </div>
  );
};

export default FloatingButton;
